export * from '@lazy-cjk/zh-convert-table/wikipedia';
import m from '@lazy-cjk/zh-convert-table/wikipedia';

export default m;

